import { Upload } from "lucide-react";
import { useRef } from "react";
import { cn } from "@/lib/utils";

interface FileUploadProps {
  accept: string;
  onFileSelect: (files: File[]) => void;
  label: string;
  icon?: React.ReactNode;
  className?: string;
  description?: string;
  multiple?: boolean;
}

export const FileUpload = ({ accept, onFileSelect, label, icon, className, multiple }: FileUploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onFileSelect(files);
    }
  };

  return (
    <div
      onClick={() => inputRef.current?.click()}
      className={cn(
        "border-2 border-dashed border-border rounded-lg p-8 cursor-pointer transition-all hover:border-primary hover:bg-muted/50",
        className
      )}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        className="hidden"
        multiple={multiple}
      />
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="p-4 rounded-full bg-primary/10 text-primary">
          {icon || <Upload className="w-6 h-6" />}
        </div>
        <div>
          <p className="font-medium text-foreground">{label}</p>
          <p className="text-sm text-muted-foreground mt-1">Click to browse</p>
        </div>
      </div>
    </div>
  );
};
